export default __webpack_public_path__ + "static/media/REFIN_IMMAGINI-PRESTIGIO-DECORI_IMPERO_mesh_265.576c80f6.jpg";